import QuestionsList from './QuestionsListContainer';
export default QuestionsList;
